import type {
  CoreApiRequestPayload,
  CoreUserTaxProfile,
  CoreUserTaxProfilePayload,
} from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

export async function updateUserTaxProfile(
  payload: CoreUserTaxProfilePayload
): Promise<CoreUserTaxProfile> {
  const body: CoreApiRequestPayload<CoreUserTaxProfilePayload> = {
    data: {
      type: 'user_tax_profile',
      attributes: payload,
    },
  }

  const response = await api.put('/api/saas/me/tax_profile', body)
  const { data } = deserialize<CoreUserTaxProfile>(response.data)

  return data
}
